module.exports = __webpack_public_path__ + "img/ic_32_sport_eishockey.98885c9b.svg";